<script>
import api from '@/helpers/api'
import { required, helpers } from 'vuelidate/lib/validators'

const isUnique = param => value => {
  return !helpers.req(value) || (param && param.indexOf(value) === -1)
}

export default {
  name: 'product-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    preset: { type: Object, default: () => {} }
  },
  data: () => ({
    product: {},
    isLoading: false
  }),
  methods: {
    reset () {
      this.product = { ...this.preset }
      this.$v.$reset()
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },

    async onSave () {
      let valid = true

      if (valid) {
        try {
          let item
          this.isLoading = true

          item = await api.items.create({
            ...this.product
          })

          this.$bvToast.toast(`Product '${this.product.code}' was added!`, {
            title: 'Product Added',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false

          this.$emit('created', item)
          this.onCancel()
        } catch (err) {
          this.$bvToast.toast(`${err}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    }
  },
  watch: {
    visible: {
      handler (v) {
        if (v) this.reset()
      }
    }
  },
  computed: {
    title () {
      return 'New Product'
    },
    saveBtnLabel () {
      return 'Create Product'
    }
  },
  validations () {
    return {
      product: {
        code: {
          required,
          async unique (v) {
            return (
              !helpers.req(v) || (await api.items.codeIsUnique({ value: v }))
            )
          }
        }
      }
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
  >
    <b-form-group label="Code *" label-for="product_code" label-cols-sm="3">
      <b-form-input
        id="product_code"
        v-model="product.code"
        type="text"
        autocomplete="product_code"
        placeholder="Unique Code"
        v-on:blur="$v.product.code.$touch()"
        :class="{ 'is-invalid': $v.product.code.$error }"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Description"
      label-for="product_description"
      label-cols-sm="3"
    >
      <b-form-textarea
        id="product_description"
        v-model="product.short_description"
        type="text"
        autocomplete="product_description"
        placeholder="Short description"
        rows="2"
      ></b-form-textarea>
    </b-form-group>
    <h4 class="card-title border-bottom pb-3 mb-2 mt-4">Options</h4>
    <b-form-group label-for="is_sellable" label-cols-sm="3">
      <template v-slot:label> Available for Sale </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_sellable"
        v-model="product.is_sellable"
        name="is_sellable"
        class="py-2"
      ></b-form-checkbox>
    </b-form-group>
    <b-form-group label-for="is_purchaseable " label-cols-sm="3">
      <template v-slot:label> Enable Purchasing </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_purchaseable "
        v-model="product.is_purchaseable"
        name="is_purchaseable "
        class="py-2"
      ></b-form-checkbox>
    </b-form-group>
    <b-form-group label-for="is_stock_item" label-cols-sm="3">
      <template v-slot:label> Manage Inventory </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_stock_item"
        v-model="product.is_stock_item"
        name="is_stock_item"
        class="py-2"
        :disabled="product.is_assembly"
      ></b-form-checkbox>
    </b-form-group>
    <b-form-group label-for="is_assembly" label-cols-sm="3">
      <template v-slot:label> Assembly Product </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_assembly"
        v-model="product.is_assembly"
        name="is_assembly"
        class="py-2"
      ></b-form-checkbox>
    </b-form-group>
    <b-form-group label-for="is_material" label-cols-sm="3">
      <template v-slot:label> Is Material </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_material"
        v-model="product.is_material"
        name="is_material"
        class="py-2"
      ></b-form-checkbox>
    </b-form-group>
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn
            variant="primary"
            class="btn-label"
            @click="onSave"
            :disabled="$v.$invalid"
          >
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
